<template>
  <vs-popup :title="$t('ViewSerials')" :active.sync="popupActive">
    <div>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[{ title: $t('Serial'), sort: 'Serial' }]"
      >
        <template slot-scope="{ row }">
          <td style="width: 96%">
            {{ row.serial }}
          </td>
        </template>
      </data-grid>
    </div>
  </vs-popup>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "warehouseManagement_invwetoryTransactions_Serlist",
  props: {
    show: { default: false },
    popupService: {},
  },
  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  watch: {
    show() {
      this.gridDataSource = { type: "app", service: this.popupService };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
  },
  components: {
    DataGrid,
  },
};
</script>
